var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:_vm.getClasses,attrs:{"type":_vm.type}},_vm.$listeners),[(_vm.icon)?_c('span',{class:['icon', { 'is-small': _vm.small }]},[(!_vm.loading)?_c('i',{class:`fas ${_vm.icon}`}):_vm._e()]):_vm._e(),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }